let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fG3MG")).then(() => parcelRequire('crJDK'));